module.exports = __webpack_public_path__ + "static/media/paper-girls-vol6.7162cf5b.jpg";